import { render } from "./LeftMenu.vue?vue&type=template&id=f4fb052c&scoped=true"
import script from "./LeftMenu.vue?vue&type=script&lang=js"
export * from "./LeftMenu.vue?vue&type=script&lang=js"

import "./LeftMenu.vue?vue&type=style&index=0&id=f4fb052c&scoped=true&lang=css"

import exportComponent from "/root/.jenkins/workspace/prod-mdcms-admin/md-cms/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4fb052c"]])

export default __exports__